import { render, staticRenderFns } from "./OmnichannelConfirmModal.vue?vue&type=template&id=524c1756&scoped=true"
import script from "./OmnichannelConfirmModal.vue?vue&type=script&lang=ts"
export * from "./OmnichannelConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelConfirmModal.vue?vue&type=style&index=0&id=524c1756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c1756",
  null
  
)

export default component.exports